export default __webpack_public_path__ + "assets/images/0c71d1acf010efb1ddaa45ec252f9f63.jpg";